export default __webpack_public_path__ + "static/media/malbec.c74aa310.png";